import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers';
import * as fromComplicationNameSearch from './complication-name-search.reducer';

export const selectComplicationNameSearch = (state: AppState) => state.complicationNameSearch;

export const searchParams = createSelector(
	selectComplicationNameSearch,
	(state: fromComplicationNameSearch.State) => ({
		queryTerm: state.queryTerm,
		resultsPerAppend: state.resultsPerAppend,
		appendsRetrieved: state.appendsRetrieved
	})
);

export const queryTerm = createSelector(
	selectComplicationNameSearch,
	(state: fromComplicationNameSearch.State) => state.queryTerm
);

export const newSearchInProgress = createSelector(
	selectComplicationNameSearch,
	(state: fromComplicationNameSearch.State) => state.newSearchInProgress
);

export const searchResults = createSelector(
	selectComplicationNameSearch,
	(state: fromComplicationNameSearch.State) => state.searchResults
);

export const morePagesExist = createSelector(
	selectComplicationNameSearch,
	(state: fromComplicationNameSearch.State) => state.lastResultsRetrievedCount === state.resultsPerAppend
);